export class TestHiddenChangedEvent {
	constructor(public testID: number, public isHidden: boolean) {
	}
}

export class TestFavoriteChangedEvent {
	constructor(public testID: number, public isFavorite: boolean) {
	}
}
